import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-update-additional-subsidy',
  templateUrl: './update-additional-subsidy.component.html',
  styleUrls: ['./update-additional-subsidy.component.scss']
})
export class UpdateAdditionalSubsidyComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UpdateAdditionalSubsidyComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initializeValidators();
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      dateOfTransfer: ['', Validators.required],
      additionalSubsidyAmount: ['', Validators.required],
      pfmsReferenceNumber: ['', Validators.required],
      utrNumber: ['', Validators.required],
      state: ['', Validators.required],
      bank: ['', Validators.required],
      city: ['', Validators.required],
      branch: ['', Validators.required],
      ifscCode: ['', Validators.required],
      accountName: ['', Validators.required],
      accountNumber: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    } else {
      this.validateFormControl();
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }
}
